import React from 'react';
import { PriceDisplay } from './PriceDisplay';
export function PricingSection() {
  return <section id="comprar" className="bg-bg3 border-y border-border py-16 px-5" data-id="element-105">
      <div className="container-custom" data-id="element-106">
        <div className="text-center mb-9" data-id="element-107">
          <span className="section-tag mx-auto" data-id="element-108">Hoy y solo hoy</span>
          <h2 className="section-title" data-id="element-109">ACCEDÉ AL MÉTODO COMPLETO</h2>
        </div>

        <div className="bg-card border-2 border-pink rounded-2xl p-[48px_36px] text-center max-w-[500px] mx-auto relative overflow-hidden" data-id="element-110">
          {/* OFERTA ESPECIAL Ribbon */}
          <div className="absolute top-[14px] -right-[28px] bg-pink text-white text-[10px] tracking-[2px] font-bold py-1.5 px-10 rotate-45 translate-x-4 origin-center" data-id="element-111">
            OFERTA ESPECIAL
          </div>

          <div className="bg-[rgba(239,68,68,0.12)] border border-[rgba(239,68,68,0.3)] rounded-lg py-3 px-5 mb-7 textsm text-[#fca5a5] font-medium" data-id="element-112">
            ⏳{' '}
            <strong className="text-red font-bold" data-id="element-113">
              OFERTA DE LANZAMIENTO
            </strong>{' '}
            — Precio puede subir sin previo aviso
          </div>

          <div className="mb-1" data-id="element-114">
            <span className="text-[20px] text-muted line-through" data-id="element-115">
              Precio regular: $49.999 ARS
            </span>
          </div>

          <div className="flex justify-center mb-1" data-id="element-116">
            <PriceDisplay amount={14999} size="xl" data-id="element-117" />
          </div>

          <div className="text-[13px] text-muted mb-7" data-id="element-118">
            ARS · Pago único · Sin cuotas mensuales
          </div>

          <div className="inline-block bg-green text-white font-bold text-[13px] py-1.5 px-[18px] rounded-full mb-7" data-id="element-119">
            ¡Ahorrás $35.000 ARS hoy!
          </div>

          <a href="[CART_LINK]" className="cta-primary block w-full mx-auto" data-id="element-120">
            QUIERO MIS DISEÑOS →
          </a>

          <p className="text-xs text-muted mt-3.5" data-id="element-121">
            🔒 Pago seguro · Acceso inmediato · Garantía 30 días
          </p>
        </div>
      </div>
    </section>;
}